import type { NavigationGuard } from 'vue-router'

import { useAuthStore } from '@/stores/auth-store'

export const authGuard: NavigationGuard = async (to) => {
  const authStore = useAuthStore()

  // try to init users who already have a session
  try {
    await authStore.initAuthStore()
    if (authStore.userId !== null && to.path === '/') {
      return { path: '/dashboard', replace: true }
    }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // swallow exception
  }

  // forward to page if no role is required
  const requiredRole = to.meta?.requiresRole
  if (!requiredRole) {
    return true
  }

  // at this point a role is required.
  // if user is not logged in, redirect to login page
  try {
    await authStore.initAuthStore()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  // Admins have access to everything
  if (authStore.hasRole('admin')) {
    return true
  }

  // Dispatch to 'forbidden' on missing permission
  if (!authStore.hasRole(requiredRole)) {
    return { path: '/forbidden', query: { requiredRole, redirect: to.fullPath }, replace: true }
  }

  // otherwise forward
  return true
}
